import { Badge } from '@/components/ui/badge';
import { ACTIVITY_TYPE_LABEL } from '@/lib/crm/format';
import type { CrmActivityType } from '@/lib/crm/types';

/** Цветной бейдж типа активности (визит/звонок/email/встреча). */
export function ActivityTypeBadge({ type }: { type: CrmActivityType }) {
  const variant = type === 'visit' ? 'primary' : 'secondary';
  return (
    <Badge variant={variant} className="uppercase tracking-wide">
      {ACTIVITY_TYPE_LABEL[type]}
    </Badge>
  );
}

/** Статус активности: запланировано (только planned_at) vs выполнено (completed_at). */
export function ActivityStatusBadge({
  completed,
}: {
  completed: boolean;
}) {
  return completed ? (
    <Badge variant="primary">выполнено</Badge>
  ) : (
    <Badge variant="accent-brand">запланировано</Badge>
  );
}
